<template>
  <div v-if="value" v-bsl="value">
    <div v-if="step === 1" class="base-overlay">
      <div class="onboarding-mobile onboarding-mobile--top">
        <div class="close-button" @click.prevent="close">
          <img
            class="show icon-close-button"
            src="@/assets/images/popup/close.png"
            alt="Zamknij"
          />
        </div>
        <h3>{{$t('onboarding.homeworks_step1.title')}}</h3>
        <p class="py-3 px-6">
          {{$t('onboarding.homeworks_step1.content')}}
        </p>
        <p class="text-center pb-3 px-6">
          <span>{{$t('onboarding.homeworks_step1.content2')}}</span><span class="text-black">"</span><span class="font-bold text-blue-zoom">{{$t('onboarding.homeworks_step1.content3')}}</span><span class="text-black">"</span><span>{{$t('onboarding.homeworks_step1.content4')}}</span>
        </p>
        <div class="flex justify-center py-4 w-full">
          <button class="swiper-button" @click.prevent="nextStep">{{$t('onboarding.homeworks_step1.btn')}}</button>
        </div>
      </div>
    </div>

    <div v-if="step === 2" class="base-overlay">
      <div class="onboarding-mobile onboarding-mobile--bottom">
        <div class="close-button" @click.prevent="close">
          <img
            class="show icon-close-button"
            src="@/assets/images/popup/close.png"
            alt="Zamknij"
          />
        </div>
        <swiper class="swiper" :options="swiperOptions">
          <swiper-slide>
            <h3>{{$t('onboarding.homeworks_step2.title')}}</h3>
            <p class="pt-2 pb-12 px-6">
              {{$t('onboarding.homeworks_step2.content')}}
            </p>
          </swiper-slide>
          <swiper-slide>
            <h3>
              {{$t('onboarding.homeworks_step2.content2')}}<br />
              {{$t('onboarding.homeworks_step2.content3')}}
            </h3>
            <div>
              <img class="w-2/4 pt-6 pb-2" :src="`${homeworksSymbolsImage}`" />
            </div>
            <div class="flex justify-center pt-3 pb-12 w-full">
              <button class="swiper-button" @click.prevent="lastStep">
                {{$t('onboarding.homeworks_step2.btn')}}
              </button>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';

import HomeworksSymbolsPng from '@/assets/images/onboarding/homeworks.png';

export default {
  name: 'HomeworksMobile',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      swiperOptions: {
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    };
  },
  computed: {
    ...mapState('students', ['student']),

    homeworksSymbolsImage() {
      return HomeworksSymbolsPng;
    },
  },
  methods: {
    ...mapActions('onboarding', ['setOnboardingProperty']),

    closeOnboardingTag() {
    },

    nextOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    close() {
      this.closeOnboardingTag();
      this.setTourCookie();
      Event.$emit('hideClassList');
      Event.$emit('cancelTour');
      this.step = 1;
      this.$emit('input', !this.value);
      Event.$off('cancelTour');
      Event.$off('nextStepTour');
    },
    nextStep() {
      this.nextOnboardingTag();
      Event.$emit('nextStepTour');
      this.step = 2;
    },
    lastStep() {
      this.acceptOnboardingTag();
      this.setTourCookie();
      Event.$emit('cancelTour');
      this.step = 1;
      this.$emit('input', !this.value);
      Event.$off('cancelTour');
      Event.$off('nextStepTour');
    },

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    setTourCookie() {
      if (this.student?.id) {
        this.setOnboardingProperty({ deviceType: 'mobile', property: 'homework', value: true });
      }
    },

    startOnboarding() {
      const tour = this.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          cancelIcon: {
            enabled: true,
          },
        },
      });

      tour.addStep({
        beforeShowPromise() {
          return new Promise((resolve) => {
            Event.$emit('showClassList');
            setTimeout(() => {
              window.scrollTo(0, 0);
              resolve();
            }, 500);
          });
        },
        attachTo: {
          element: '.classList',
        },
        canClickTarget: false,
        modalOverlayOpeningRadius: 20,
      });

      tour.addStep({
        beforeShowPromise() {
          return new Promise((resolve) => {
            Event.$emit('hideClassList');
            setTimeout(() => {
              window.scrollTo(0, 0);
              resolve();
            }, 500);
          });
        },
        attachTo: {
          element: '.tasklist',
        },
        canClickTarget: false,
        modalOverlayOpeningRadius: 12,
      });

      tour.start();

      Event.$on('cancelTour', () => {
        tour.cancel();
      });

      Event.$on('nextStepTour', () => {
        tour.next();
      });
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
    Event.$off('nextStepTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-overlay {
  @apply fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99998;
  overflow-y: auto;
  animation: fade 0.5s ease-in-out both;
}
.onboarding-mobile {
  @apply absolute pb-4 bg-white text-black w-full text-center;
  border-radius: 20px;
  top: 40%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%);
  min-height: 200px;
  max-width: calc(100% - 20px);
  max-height: calc(100% - 20px);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.12), 0 4px 10px rgba(0, 0, 0, 0.24);
  &--bottom {
    top: auto;
    bottom: 2%;
    transform: translate(-50%, 0);
  }
  &--top {
    top: 2%;
    transform: translate(-50%, 0);
    @media screen and (min-height: 700px) {
      top: 15%;
    }
  }
  h3 {
    @apply font-bold text-lg pt-12 pb-2;
    line-height: 25px;
  }
  p {
    @apply text-base;
    line-height: 30px;
  }
  .close-button {
    @apply cursor-pointer absolute text-center;
    z-index: 99999;
    height: 20px;
    width: 20px;
    top: 5px;
    right: 20px;
    opacity: 0.5;
    img {
      margin-top: 11px;
    }
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.swiper-pagination-bullet {
  width: 14px;
  height: 14px;
  border: 1px solid #000;
  background: #fff;
  opacity: 0.3;
}

.swiper-pagination-bullet-active {
  @apply bg-blue;
  border: 1px solid #3e9bd3;
  opacity: 1;
}

.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 8px;
}

.swiper-button {
  @apply block bg-blue text-white px-12 py-0 cursor-pointer font-bold;
  border-radius: 100px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    @apply bg-blue text-white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
  &:not(:disabled):hover {
    @apply text-white bg-blue;
  }
}
</style>
